import FetchService from '../../../core/services/FetchService';
import { action, extendObservable } from 'mobx';

class LoadMasteryTestService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      masteryTest: null,
    });
  }

  handleLoad = action((moduleId, masteryTestId) => {
    this.fetch
      .fetch({
        url: `/modules/${moduleId}/mastery-tests/${masteryTestId}`,
      })
      .then(
        action(() => {
          if (this.fetch.data) {
            this.masteryTest = this.fetch.data;
          }
        })
      );
  });
}

export default LoadMasteryTestService;
